<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditWarehouseModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">Update Warehouse</span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Country *"
                    v-model="formData.country"
                    :error-messages="errors.collect('Country')"
                    v-validate="'required'"
                    data-vv-name="Country"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="Name *"
                    v-model="formData.name"
                    :error-messages="errors.collect('Name')"
                    v-validate="'required'"
                    data-vv-name="Name"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="City"
                    v-model="formData.city"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="Code"
                    v-model="formData.code"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="Street"
                    v-model="formData.street"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="Phone Number"
                    v-model="formData.phone_number"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="House Number"
                    v-model="formData.house_number"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="State - Province"
                    v-model="formData.state_province"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    label="Prefix"
                    v-model="formData.prefix"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-select
                    v-model="formData.transportation_type_ids"
                    :items="transportationTypes"
                    item-text="name"
                    item-value="id"
                    multiple
                    chips
                    label="Transportation Types"
                  ></v-select>
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <label for="logo">Logo</label>
                  <input
                    ref="logoRef"
                    type="file"
                    id="logo"
                    name="logo"
                    accept="image/*"
                    @input="logoChange()"
                  >
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <label for="logo">Default Image</label>
                  <input
                    ref="defaultImageRef"
                    type="file"
                    id="logo"
                    name="logo"
                    accept="image/*"
                    @input="defaultImageChange()"
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditWarehouseModal', 'formData', 'isUpdate', 'transportationTypes'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    logoChange() {
      this.formData.logo = this.$refs.logoRef.files[0]
    },

    defaultImageChange() {
      this.formData.default_image = this.$refs.defaultImageRef.files[0]
    },

    clearFiles() {
      this.$refs.logoRef.value = ''
      this.$refs.defaultImageRef.value = ''
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            let fd = new FormData()

            if (this.formData.transportation_type_ids.length) {
              this.formData.transportation_type_ids = this.formData.transportation_type_ids.join(',')
            }

            for (let key in this.formData) {
              if (this.formData[key]) {
                fd.append(key, this.formData[key])
              }
            }

            fd.append('_method', 'put')

            Axios.post(`api/warehouses/${this.formData.warehouse_id}`, fd, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.clearFiles()
                swal({
                  title: 'Updated successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal('Error', error.response.data.message, 'error')
              })
          } else {
            let fd = new FormData()

            if (this.formData.transportation_type_ids.length) {
              this.formData.transportation_type_ids = this.formData.transportation_type_ids.join(',')
            }

            for (let key in this.formData) {
              if (this.formData[key]) {
                fd.append(key, this.formData[key])
              }
            }

            Axios.post(`api/warehouses`, fd, {
              headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            })
              .then(() => {
                this.clearFiles()
                swal({
                  title: 'Add successfully',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal('Error', error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouse/addEditWarehouse.vue